import React, { FC, createElement, useEffect, useState } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';
import SurgeTabs from '../surge-tabs';
import GeneralSurgeApplyNow from './general-surge-apply-now';
import GeneralSurgeSchedule from './general-surge-schedule';
import GeneralSurgeHistory from './general-surge-history';
import EditGeneralSurge from '../edit-general';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import { EditSurgeTabType, SurgeTabProps, SurgeTabType } from '../surge-tabs/types';
import { ActiveGeneralSurgeType } from 'models/surge.model';

type Props = {
  show: boolean;
  onClose: () => void;
  activeSurge: ActiveGeneralSurgeType;
  defaultActiveTab?: SurgeTabType;
};

const GeneralSurgeModal: FC<Props> = ({ show, onClose, activeSurge, defaultActiveTab }) => {
  const [active, setActive] = useState<SurgeTabType>(defaultActiveTab ?? 'Apply Now');
  const [trigger, setTrigger] = useState('' as EditSurgeTabType);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (show) {
      setTrigger('' as EditSurgeTabType);
      setActive(defaultActiveTab ?? 'Apply Now');
      setStep(1);
    }
  }, [show]);

  const onConfirm = () => {
    if (step === 3) {
      setTrigger('Edit');
    } else {
      setTrigger(active);
    }
  };

  const tabList: SurgeTabType[] = [
    'Apply Now',
    'Schedule',
    'History'
    //  'Fleets'
  ];
  const tabComponents: Record<SurgeTabType, FC<any>> = {
    'Apply Now': GeneralSurgeApplyNow,
    Schedule: GeneralSurgeSchedule,
    History: GeneralSurgeHistory
    // Fleets: AssignFleet
  };

  const onBackModal = () => {
    setStep((prev) => prev - 1);
  };

  const hideConfirmButton = () => {
    return active === 'History' || step === 2;
    // || active === 'Fleets';
  };
  return (
    <BaseModal
      isOpen={show}
      title={step === 1 ? 'Manage General Surge' : 'Edit Schedule Surge'}
      description={
        step === 1
          ? 'Applying surge multiplies the delivery price by the appropriate value.'
          : undefined
      }
      titleIcon={<TitleIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      hasBackButton={step !== 1}
      onBackButton={onBackModal}
      titleCta={
        step === 1 ? (
          <p
            onClick={() => {
              setStep(step + 1);
            }}
            className='text-[#E60A2B] underline text-sm cursor-pointer'>
            Edit Scheduled surge
          </p>
        ) : undefined
      }
      footer={
        hideConfirmButton() ? undefined : (
          <Button small color='primary' variant='block' loading={loading} onClick={onConfirm}>
            Confirm
          </Button>
        )
      }>
      <div>
        {step === 1 ? (
          <>
            <SurgeTabs
              defaultActiveTab={defaultActiveTab}
              list={tabList}
              active={active}
              setActive={setActive}
            />
            {createElement(tabComponents[active] as FC<SurgeTabProps>, {
              confirm: trigger,
              setLoading: setLoading,
              onClose: onClose,
              activeSurge: activeSurge
            })}
          </>
        ) : (
          <EditGeneralSurge
            confirm={trigger}
            setLoading={setLoading}
            onClose={onClose}
            setStep={setStep}
            step={step}
          />
        )}
      </div>
    </BaseModal>
  );
};

export default GeneralSurgeModal;
